import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
import styles from "./base-card.module.css";
const BaseCard = ({ children , className , element ="div" , hasBoxShadow =false , hasBorder =false , ...rest })=>{
    const HtmlElement = element;
    const classes = classNames({
        [styles.cardBoxShadow]: hasBoxShadow,
        [styles.cardBorder]: hasBorder
    }, className, styles.card);
    return /*#__PURE__*/ _jsx(HtmlElement, {
        className: classes,
        "data-testid": "Atoms/Base-Card",
        ...rest,
        children: children
    });
};
export default BaseCard;
